(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.factory("ContactInfoService", [
        "ContactInfo", 
        function(
            ContactInfo
        ){
        var service = {
            data: {
                contactinfotypes: []
            },
            // list of possible contact-info-types (UserContactInfoType-Objects)
            createContactInfoByTypeValue: createContactInfoByTypeValue,
        };
        return service;

        // make new contact-info object by contact-info-type
        function createContactInfoByTypeValue(type) {
            if (!type) {
                return null;
            }
            var i = 0;
            var len = service.data.contactinfotypes.length;
            for (i = 0; i < len; i++) {
                if (service.data.contactinfotypes[i].type === type) {
                    var info = new ContactInfo();
                    info.init(service.data.contactinfotypes[i]);
                    return info;
                } // if
            } // for
        } // createContactInfoByType
    }
]);
})();